
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Footer Cell Style" fileName="cell-style.md" />
        <demo-block>
        <div><p>1、The callback function <code>footerCellClass({ row, column, rowIndex })</code> receives 3 parameters,row：Current row data、column:Current column option、rowIndex:Row index<br>2、Returns the qualified cells to the specified class name,class name is custom<br>3、If you need to set the background color or font color to cells, you need to add <code>!important</code></p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table
        border-y
        fixed-header
        :max-height=&quot;300&quot;
        :columns=&quot;columns&quot;
        :table-data=&quot;tableData&quot;
        :footer-data=&quot;footerData&quot;
        :cell-style-option=&quot;cellStyleOption&quot;
        rowKeyFieldName=&quot;rowKey&quot;
    /&gt;
&lt;/template&gt;

&lt;style&gt;
    .table-footer-cell-class1 {
        background: #91d5ff !important;
        color: #fff !important;
    }

    .table-footer-cell-class2 {
        background: orange !important;
        color: #fff !important;
    }
&lt;/style&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                cellStyleOption: {
                    footerCellClass: ({ row, column, rowIndex }) =&gt; {
                        if (column.field === &quot;address&quot;) {
                            return &quot;table-footer-cell-class1&quot;;
                        }

                        if (column.field === &quot;date&quot; &amp;&amp; rowIndex === 1) {
                            return &quot;table-footer-cell-class2&quot;;
                        }
                    },
                },
                columns: [
                    { field: &quot;name&quot;, key: &quot;a&quot;, title: &quot;Name&quot;, align: &quot;left&quot; },
                    { field: &quot;date&quot;, key: &quot;b&quot;, title: &quot;Date&quot;, align: &quot;left&quot; },
                    { field: &quot;hobby&quot;, key: &quot;c&quot;, title: &quot;Hobby&quot;, align: &quot;left&quot; },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 15; i++) {
                    data.push({
                        rowKey: i,
                        name: i,
                        date: i,
                        hobby: i,
                        address: i,
                    });
                }
                this.tableData = data;
            },

            initFooterData() {
                this.footerData = [
                    {
                        rowKey: 0,
                        name: &quot;Average Values&quot;,
                        date: 213,
                        hobby: 355,
                        address: 189,
                    },
                    {
                        rowKey: 1,
                        name: &quot;Summary Values&quot;,
                        date: 1780,
                        hobby: 890,
                        address: 2988,
                    },
                ];
            },
        },
        created() {
            this.initTableData();
            this.initFooterData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"border-y":"","fixed-header":"","max-height":300,"columns":_vm.columns,"table-data":_vm.tableData,"footer-data":_vm.footerData,"cell-style-option":_vm.cellStyleOption,"rowKeyFieldName":"rowKey"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                cellStyleOption: {
                    footerCellClass: ({ row, column, rowIndex }) => {
                        if (column.field === "address") {
                            return "table-footer-cell-class1";
                        }

                        if (column.field === "date" && rowIndex === 1) {
                            return "table-footer-cell-class2";
                        }
                    },
                },
                columns: [
                    { field: "name", key: "a", title: "Name", align: "left" },
                    { field: "date", key: "b", title: "Date", align: "left" },
                    { field: "hobby", key: "c", title: "Hobby", align: "left" },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                tableData: [],
            };
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 15; i++) {
                    data.push({
                        rowKey: i,
                        name: i,
                        date: i,
                        hobby: i,
                        address: i,
                    });
                }
                this.tableData = data;
            },

            initFooterData() {
                this.footerData = [
                    {
                        rowKey: 0,
                        name: "Average Values",
                        date: 213,
                        hobby: 355,
                        address: 189,
                    },
                    {
                        rowKey: 1,
                        name: "Summary Values",
                        date: 1780,
                        hobby: 890,
                        address: 2988,
                    },
                ];
            },
        },
        created() {
            this.initTableData();
            this.initFooterData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      .table-footer-cell-class1 {
        background: #91d5ff !important;
        color: #fff !important;
    }

    .table-footer-cell-class2 {
        background: orange !important;
        color: #fff !important;
    }
    </style>
  